export type ExpertiseValues =
  | 'AGRICULTURE'
  | 'ANIMALS'
  | 'DESIGN'
  | 'HANDCRAFT'
  | 'BUILDING'
  | 'COACHING'
  | 'AUDIOVISUAL'
  | 'ACCOUNTING'
  | 'SECURITY'
  | 'ENVIRONMENT'
  | 'LAW'
  | 'EDUCATION'
  | 'INDUSTRIAL'
  | 'COMPUTER_SCIENCE'
  | 'INTERNATIONAL'
  | 'LITTERATURE'
  | 'MARKETING'
  | 'HUMAN_RESOURCES'
  | 'HEALTH'
  | 'TECHNOLOGY'
  | 'POLITICS'
  | 'ADMINISTRATION'
  | 'PUBLIC'
  | 'LOCAL'
  | 'SPORT'
  | 'TOURISM'
  | 'SOCIAL'
  | 'ARCHITECTURE'
  | 'DONT_KNOW';

export const expertises: ExpertiseValues[] = [
  'AGRICULTURE',
  'ANIMALS',
  'DESIGN',
  'HANDCRAFT',
  'BUILDING',
  'COACHING',
  'AUDIOVISUAL',
  'ACCOUNTING',
  'SECURITY',
  'ENVIRONMENT',
  'LAW',
  'EDUCATION',
  'INDUSTRIAL',
  'COMPUTER_SCIENCE',
  'INTERNATIONAL',
  'LITTERATURE',
  'MARKETING',
  'HUMAN_RESOURCES',
  'HEALTH',
  'TECHNOLOGY',
  'POLITICS',
  'ADMINISTRATION',
  'PUBLIC',
  'LOCAL',
  'SPORT',
  'TOURISM',
  'SOCIAL',
  'ARCHITECTURE',
  'DONT_KNOW',
];

enum EXPERTISE {
  AGRICULTURE = 'Agriculture, alimentation',
  ANIMALS = 'Animaux',
  DESIGN = 'Art et culture, design',
  HANDCRAFT = 'Artisanat, petit commerce',
  BUILDING = 'BTP, immobilier',
  COACHING = 'Coaching, développement personnel, bien être',
  AUDIOVISUAL = 'Communication, journalisme, audiovisuel, graphisme',
  ACCOUNTING = 'Comptabilité, gestion, assurance',
  SECURITY = 'Défense, sécurité',
  ENVIRONMENT = 'Développement durable, énergie, environnement, RSE',
  LAW = 'Droit',
  EDUCATION = 'Enseignement, éducation, animation',
  INDUSTRIAL = 'Industrie, logistique',
  COMPUTER_SCIENCE = 'Informatique, digital',
  INTERNATIONAL = 'International, solidarité internationale',
  LITTERATURE = 'Littérature, livre, langues',
  MARKETING = 'Management, marketing, conseil, stratégie, finance',
  HUMAN_RESOURCES = 'Ressources humaines',
  HEALTH = 'Santé, soin à la personne',
  TECHNOLOGY = 'Sciences et technologies',
  POLITICS = 'Sciences humaines et sociales, sciences politiques, histoire, géographie',
  ADMINISTRATION = 'Secrétariat, fonctions administratives',
  PUBLIC = 'Secteur public',
  LOCAL = 'Solidarité locale, action sociale',
  SPORT = 'Sport',
  TOURISM = 'Tourisme',
  SOCIAL = 'Travail social',
  ARCHITECTURE = 'Urbanisme et paysage, architecture',
  DONT_KNOW = 'Je ne sais pas encore',
}
export default EXPERTISE;
